import { render, staticRenderFns } from "./assignment-comment-task-modal.vue?vue&type=template&id=58bd5943&scoped=true"
import script from "./assignment-comment-task-modal.vue?vue&type=script&lang=js"
export * from "./assignment-comment-task-modal.vue?vue&type=script&lang=js"
import style0 from "./assignment-comment-task-modal.vue?vue&type=style&index=0&id=58bd5943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bd5943",
  null
  
)

export default component.exports